"use strict";

var React = require("react");
module.exports = React.createElement(
  "svg",
  { viewBox: "0 0 36 36" },
  React.createElement("path", { d: "M30 1.417a1 1 0 0 0-1.27-.965l-16 4.448a1 1 0 0 0-.73.963v18.55a6.63 6.63 0 0 0-6.144.057c-3.114 1.515-4.687 4.7-3.515 7.1s4.646 3.132 7.76 1.616A6.434 6.434 0 0 0 14 27.857V10.824l14-4v13.589a6.63 6.63 0 0 0-6.144.057c-3.114 1.515-4.687 4.7-3.515 7.1s4.646 3.132 7.76 1.616A6.427 6.427 0 0 0 30 23.833V1.417z" })
);

